// TODO remove redux
import { Provider } from 'react-redux';

import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { SWRConfig } from 'swr';

// TODO upd mui to v7
import { ThemeProvider, createTheme } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { store } from './store';
import './v2/utils/dayjs';

import { App } from './App';

import './index.css';
// TODO remove wbs
import 'wbs-components-lib/dist/style.css';

const theme = createTheme({
  palette: {
    primary: { main: '#18181b' },
  },
  typography: {
    fontFamily: `'Lato', 'sans-serif'`,
    button: { textTransform: 'none' },
  },
});

createRoot(document.getElementById('root')!).render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <SWRConfig value={{ errorRetryCount: 1, revalidateOnMount: true, revalidateOnFocus: false }}>
            <App />

            <Toaster position="top-right" duration={4000} expand={false} richColors closeButton />
          </SWRConfig>
        </LocalizationProvider>
      </StyledEngineProvider>
    </Provider>
  </ThemeProvider>
);
